import { render, staticRenderFns } from "./UserRoleSelectionModal.vue?vue&type=template&id=95f59b10&scoped=true"
import script from "./UserRoleSelectionModal.vue?vue&type=script&lang=js"
export * from "./UserRoleSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./UserRoleSelectionModal.vue?vue&type=style&index=0&id=95f59b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f59b10",
  null
  
)

export default component.exports